import React from 'react';
import {FlatList} from 'react-native';

import {Footer} from '../Footer';
import {getPersonId} from '../SearchResultItem/SearchResultItem.util';

import {styles} from './SearchResults.style';
interface SearchResultsProps {
  searchResults: any[];
  renderItem: ({item}: {item: any}) => JSX.Element;
  recentSearches: any[];
  isRecentSearches: boolean;
  recordsParams: Record<string, any>;
}
export const SearchResults: React.FC<SearchResultsProps> = ({
  searchResults,
  renderItem,
  recentSearches,
  isRecentSearches,
  recordsParams,
}) => {
  return (
    <FlatList
      style={styles.flatList}
      contentContainerStyle={styles.conentContainer}
      data={isRecentSearches ? recentSearches : searchResults}
      keyExtractor={getPersonId}
      renderItem={renderItem}
      ListFooterComponent={<Footer recordsParams={recordsParams} />}
      showsVerticalScrollIndicator={false}
    />
  );
};
